"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const AddFile = createSVGIcon(
  <>
    <path
      d="M4.286 9.429V2.57A1.714 1.714 0 0 1 6 .857h8.571l8.572 8.572v12a1.714 1.714 0 0 1-1.715 1.714h-8.57"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.571.857V9.43h8.572M6 12.857v10.286M.857 18h10.286"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "AddFile",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Add File",
      description: {
        text: "Message for screenreaders when only the add file icon is displayed",
      },
    }),
    fill: "none",
  })
);
